import React, { useState } from "react";
import "./LocationSnapshot.scss";
import { LocationProps } from "./LocationSnapshot.types";
import Camera, { FACING_MODES } from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";
import { Button } from "../Button";
import Loader from "../../utilities/Loader";
const LocationSnapshot = ({
  submit,
  isSpinner,
}: {
  submit: any;
  isSpinner: boolean;
}) => {
  const [dataURI, setdataURI] = useState("");
  const [imageTaken, setImageTaken] = useState(false);
  const retakePhoto = () => {
    setImageTaken(false);
  };
  const [btnLoading, setBtnLoading] = React.useState(false);
  //sending the captured snap data to parent component
  const submitBtn = () => {
    submit(dataURI);
  };
  React.useEffect(() => {
    setBtnLoading(isSpinner);
  }, [isSpinner]);
  return (
    <div className="flex jc-c">
      {!imageTaken && (
        <div>
          {/* //camera container */}
          <Camera
            isFullscreen={true}
            onTakePhoto={(data: any) => {
              setdataURI(data); //capturing the snap data
              setImageTaken(true);
            }}
            idealFacingMode={FACING_MODES.ENVIRONMENT}
          />
          <div className="bottom-text">
            <div>Tap here to Take Site Photo</div>
          </div>
        </div>
      )}
      {/* //show captured image container */}
      {imageTaken && (
        <div>
          <div>
            <img className="imageTaken" src={dataURI} alt="" />
            <div className="block">
              {/* // click image button */}
              <Button
                isRounded={true}
                className="margin-bottom"
                onClick={() => retakePhoto()}
              >
                Retake
              </Button>
              <Button
                isRounded={true}
                className="margin-bottom"
                onClick={() => submitBtn()}
              >
                {btnLoading ? (
                  <Loader
                    color="#fff"
                    loading={btnLoading}
                    size={10}
                    height="auto"
                  />
                ) : (
                  "Submit"
                )}
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LocationSnapshot;
